module.exports = __webpack_public_path__ + "img/zhihuigushi@3x.8b2a530b.png";